import React from "react";
import AdminCrud from "@/components/AdminCrud";

export default function AdminBlog() {
  return (
    <AdminCrud
      title="Blog"
      resource="blog"
      initialItem={{ status: "published", author: "Marupiara Editoração" }}
      fields={[
        { name: "title", label: "Título", required: true },
        { name: "slug", label: "Slug", required: true },
        { name: "excerpt", label: "Resumo", textarea: true, rows: 2 },
        { name: "cover_url", label: "Imagem de capa do artigo", type: "image" },
        { name: "category", label: "Categoria" },
        { name: "author", label: "Autor do artigo" },
        { name: "content", label: "Conteúdo (HTML permitido)", textarea: true, rows: 10 },
        { name: "published_at", label: "Data de publicação (ISO)", help: "Ex: 2026-03-15T10:00:00Z" },
        { name: "meta_title", label: "SEO — Meta Title" },
        { name: "meta_description", label: "SEO — Meta Description", textarea: true, rows: 2 },
      ]}
      columns={[
        { name: "title", label: "Título" },
        { name: "category", label: "Categoria" },
        { name: "author", label: "Autor" },
      ]}
    />
  );
}
